import {
	Breakpoints,
	Layout,
	LayoutRowGap,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import {
	CarlineSelect,
	DetalleMotivo,
	InicioEncuesta,
	MultipleCTASelection,
	NombreApellidos,
	RatingStars,
} from 'src/components';
import { RadioTextGroup } from 'src/components/inputs/RadioTextGroup';
import { CTAsSiNo } from 'src/feature-app/InputsValues';
import { ConfirmacionCem } from 'src/forms/Cem/ConfirmacionCem';
import { Steps } from 'src/types';
import {
	valueWrongConcesion,
	valueWrongMarca,
	valueWrongModelo,
	valueWrongPersona,
} from '../helpers/data';
import { CEMVentaProductoFirstStepComerciales } from './CEMVentaProductoFirstStepComerciales';

function LayoutTemplate(props: any) {
	const { element } = props;

	return (
		<Layout
			allowOverflowingContent
			appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 2 },
					{ name: 'a', columns: 20 },
					{ name: '.', columns: 2 },
				],
				[Breakpoints.b960]: [
					{ name: '.', columns: 3 },
					{ name: 'a', columns: 18 },
					{ name: '.', columns: 3 },
				],
				[Breakpoints.b1280]: [
					{ name: '.', columns: 5 },
					{ name: 'a', columns: 14 },
					{ name: '.', columns: 5 },
				],
				[Breakpoints.b1920]: [
					{ name: '.', columns: 6 },
					{ name: 'a', columns: 12 },
					{ name: '.', columns: 6 },
				],
				[Breakpoints.b2560]: [
					{ name: '.', columns: 7 },
					{ name: 'a', columns: 10 },
					{ name: '.', columns: 7 },
				],
			}}
			rowGap={LayoutRowGap.static300}
		>
			{element}
		</Layout>
	);
}

export const getStepsVentaProductoComerciales = (
	isElectrico: boolean,
	isHibrido: boolean,
	isCamper: boolean,
	carline: string,
	installation: string,
) => {
	const isCombustion = !isElectrico && !isHibrido;
	let index = 0;

	const ctaDatosIncorrectos = [
		{
			label: 'Marca incorrecta',
			value: valueWrongMarca.toString(),
		},
		{
			label: 'Modelo incorrecto',
			value: valueWrongModelo.toString(),
		},
		{
			label: 'Punto de venta incorrecto',
			value: valueWrongConcesion.toString(),
		},
		{
			label: 'Persona de contacto incorrecta',
			value: valueWrongPersona.toString(),
		},
	];

	const optionsEnviarConcesion = [
		{
			value: '1',
			label: 'Sí, mis respuestas pueden ser enviadas y analizadas junto a mi nombre y al número de bastidor de mi vehículo, para el alcance descrito anteriormente (el consentimiento puede revocarse en cualquier momento a través de los canales de contacto que se indican a continuación*).',
			info: '*Puedo revocar este consentimiento en cualquier momento sin dar motivos a mi Distribuidor para mis datos personalizados.',
		},
		{
			value: '2',
			label: 'Mis respuestas pueden ser enviadas pero sin mencionar mi nombre ni el bastidor del vehículo.',
			info: 'Seleccionando esta opción, el punto de venta no podrá ponerse en contacto contigo en relación a tus comentarios.',
		},
		{
			value: '0',
			label: 'No, mis respuestas solo deben ser analizadas de manera anónima (seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos)',
			info: 'Seleccionando esta opción, tus respuestas serán analizadas de modo agregado junto al resto de respuestas de todos los entrevistados y no se trasladarán a los comentarios abiertos.',
		},
	];

	const ctasUsoCliente = [
		{
			label: 'Exclusivamente profesional',
			value: '1',
		},
		{
			label: 'Profesional y particular (mixto)',
			value: '2',
		},
		{
			label: 'Exclusivamente particular',
			value: '3',
		},
		{
			label: 'Sin respuesta',
			value: '9',
		},
	];

	const firstStep = {
		fields: <CEMVentaProductoFirstStepComerciales />,
		screenIndex: index++,
		name: 'isDatosCorrectos',
		alternateTitle: (
			<Text>¿Puedes confirmar que estos datos son correctos?</Text>
		),
		outputs: ['isDatosCorrectos'],
		outputsText: ['isDatosCorrectos'],
		trueOrFalsequestion: true,
	};

	const confirmacionDatos = {
		title: (
			<>
				Por favor,{' '}
				<Text bold>¿puedes confirmar qué dato no es correcto?</Text>
			</>
		),
		fields: (
			<LayoutTemplate
				element={
					<MultipleCTASelection
						ctaValues={ctaDatosIncorrectos}
						name="datoIncorrecto"
						nextOnClick
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'datoIncorrecto',
		outputs: ['datoIncorrecto'],
		outputsText: ['datoIncorrecto'],
		ctas: ctaDatosIncorrectos,
	};

	const confirmacionConcesion = {
		title: (
			<Text bold>
				¿Has comprado tu nuevo {carline} en {installation}?
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<MultipleCTASelection
						ctaValues={CTAsSiNo}
						name="confirmacionConcesion"
						nextOnClick
						ctaWidth="81"
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'confirmacionConcesion',
		outputs: ['confirmacionConcesion'],
		outputsText: ['confirmacionConcesion'],
	};

	const seleccionModelo = {
		title: <Text bold>¿Cuál es el modelo correcto?</Text>,
		fields: (
			<LayoutTemplate
				element={
					<div>
						<CarlineSelect isCEMVenta={true} useCarline={true} />
					</div>
				}
			/>
		),
		screenIndex: index++,
		name: 'seleccionModelo',
		outputs: ['seleccionModelo'],
		outputsText: ['seleccionModelo'],
	};

	const inicioRating = {
		title: (
			<>
				A continuación,{' '}
				<Text bold>
					indica tu nivel de satisfacción con cada uno de estos
					aspectos relacionados con la compra de tu último vehículo.
				</Text>
			</>
		),
		fields: (
			<InicioEncuesta bodyCopy="Valora del 1 al 5, a mayor número de estrellas más satisfacción." />
		),
		screenIndex: index++,
		name: 'inicioRating',
	};

	const getStarsStep = ({
		index,
		title,
		name,
		question,
	}: {
		index: number;
		title: string;
		name: string;
		question: JSX.Element | string;
	}) => {
		return {
			stickyTitle: (
				<>
					<div style={{ marginBottom: '10px' }}>
						<Text bold appearance={TokenTextAppearance.copy200}>
							{title}
						</Text>
					</div>
					<Text>¿Cuál es tu nivel de satisfacción con </Text>
				</>
			),
			title: <Text bold>{question}</Text>,
			fields: (
				<LayoutTemplate
					element={
						<RatingStars
							name={name}
							nextOnClick={true}
							textGood="satisfecho/a"
							textBad="insatisfecho/a"
							CTASinRespuesta
						/>
					}
				/>
			),
			screenIndex: index,
			name: name,
			outputs: [name],
			outputsText: [name],
			outputsIsStars: true,
		};
	};

	const getMotivoStep = ({
		index,
		title,
		name,
	}: {
		index: number;
		title: string;
		name: string;
	}) => {
		return {
			stickyTitle: (
				<div style={{ marginBottom: '10px' }}>
					<Text bold appearance={TokenTextAppearance.copy200}>
						{title}
					</Text>
				</div>
			),
			title: (
				<Text bold>
					¿Cuál es el motivo por el que has dado esta valoración?
				</Text>
			),
			fields: (
				<LayoutTemplate
					element={
						<DetalleMotivo
							required={true}
							name={name}
							label="Escríbelo aquí, indicando el aspecto de tu nuevo vehículo al que te refieres"
							showRecomendation="Por favor, no menciones nombres propios, direcciones, números de teléfono o descripciones que permitan identificarte a ti o a nuestros empleados."
							numberOfMaxLength={300}
							CTALabel="Sin respuesta"
						/>
					}
				/>
			),
			screenIndex: index,
			name: name,
			outputs: [name],
			outputsText: [name],
		};
	};

	/*
	 * PREGUNTAS SATISFACCION GRUPO ALEATORIO 1
	 */

	const conduccionRendimiento = getStarsStep({
		index: index++,
		title: 'Conducción',
		name: 'conduccionRendimiento',
		question: 'el rendimiento del vehículo (potencia, aceleración)?',
	});
	const conduccionComodidad = getStarsStep({
		index: index++,
		title: 'Conducción',
		name: 'conduccionComodidad',
		question: 'la comodidad de conducción?',
	});
	const conduccionConsumo = getStarsStep({
		index: index++,
		title: 'Conducción',
		name: 'conduccionConsumo',
		question: isHibrido
			? 'el consumo de combustible/energía?'
			: 'el consumo de combustible?',
	});
	const conduccionAutonomia = getStarsStep({
		index: index++,
		title: 'Conducción',
		name: 'conduccionAutonomia',
		question: 'la autonomía eléctrica?',
	});
	const conduccionMotivo = getMotivoStep({
		index: index++,
		title: 'Conducción',
		name: 'conduccionMotivo',
	});

	/*
	 * PREGUNTAS SATISFACCION GRUPO ALEATORIO 2
	 */

	const rendimientoCargaGestion = getStarsStep({
		index: index++,
		title: 'Rendimiento de carga',
		name: 'rendimientoCargaGestion',
		question:
			'la gestión del proceso de carga? (p. ej. conexión a la estación de carga, apertura de la tapa de la toma de carga...)',
	});
	const rendimientoCarga = getStarsStep({
		index: index++,
		title: 'Rendimiento de carga',
		name: 'rendimientoCarga',
		question:
			'el rendimiento de carga? (p. ej. tiempo de carga, curva de carga…)',
	});
	const rendimientoMotivo = getMotivoStep({
		index: index++,
		title: 'Rendimiento de carga',
		name: 'rendimientoMotivo',
	});

	/*
	 * PREGUNTAS SATISFACCION GRUPO ALEATORIO 3
	 */

	const exteriorDiseno = getStarsStep({
		index: index++,
		title: 'Exterior',
		name: 'exteriorDiseno',
		question: 'el diseño exterior del vehículo?',
	});
	const exteriorPuertas = getStarsStep({
		index: index++,
		title: 'Exterior',
		name: 'exteriorPuertas',
		question:
			'la apertura y el cierre de las puertas y/o puertas correderas?',
	});
	const exteriorMaletero = getStarsStep({
		index: index++,
		title: 'Exterior',
		name: 'exteriorMaletero',
		question:
			'la facilidad para cargar o descargar el maletero o la zona de carga?',
	});
	const exteriorMotivo = getMotivoStep({
		index: index++,
		title: 'Exterior',
		name: 'exteriorMotivo',
	});

	/*
	 * PREGUNTAS SATISFACCION GRUPO ALEATORIO 4
	 */

	const interiorDiseno = getStarsStep({
		index: index++,
		title: 'Interior',
		name: 'interiorDiseno',
		question: 'el diseño interior?',
	});
	const interiorAlmacenamiento = getStarsStep({
		index: index++,
		title: 'Interior',
		name: 'interiorAlmacenamiento',
		question:
			'los compartimentos de almacenamiento (número, tamaño, accesibilidad)?',
	});
	const interiorAsiento = getStarsStep({
		index: index++,
		title: 'Interior',
		name: 'interiorAsiento',
		question: 'el ajuste de la posición del asiento y su comodidad?',
	});
	const interiorFunciones = getStarsStep({
		index: index++,
		title: 'Interior',
		name: 'interiorFunciones',
		question:
			'la facilidad de uso de las funciones del vehículo (infotainment, navegación, multimedia)?',
	});
	const interiorAC = getStarsStep({
		index: index++,
		title: 'Interior',
		name: 'interiorAC',
		question: 'la calefacción, ventilación y aire acondicionado?',
	});
	const interiorMotivo = getMotivoStep({
		index: index++,
		title: 'Interior',
		name: 'interiorMotivo',
	});

	/*
	 * PREGUNTAS SATISFACCION GRUPO ALEATORIO 5
	 */

	const asistenciaConduccion = getStarsStep({
		index: index++,
		title: 'Sistemas de asistencia',
		name: 'asistenciaConduccion',
		question:
			'los sistemas de asistencia a la conducción y al aparcamiento en general?',
	});
	const asistenciaFuncionalidad = getStarsStep({
		index: index++,
		title: 'Sistemas de asistencia',
		name: 'asistenciaFuncionalidad',
		question: 'la funcionalidad de los sistemas de asistencia?',
	});
	const asistenciaNavegacion = getStarsStep({
		index: index++,
		title: 'Sistemas de asistencia',
		name: 'asistenciaNavegacion',
		question:
			'el sistema de navegación integrado? (p. ej. cálculo de rutas, búsqueda de destinos, datos de tráfico en línea…)',
	});
	const asistenciaMotivo = getMotivoStep({
		index: index++,
		title: 'Sistemas de asistencia',
		name: 'asistenciaMotivo',
	});

	/*
	 * PREGUNTAS SATISFACCION GRUPO ALEATORIO 6
	 */

	const softwareInicio = getStarsStep({
		index: index++,
		title: 'Software y conectividad',
		name: 'softwareInicio',
		question:
			'la configuración inicial del sistema de infotainment? (p. ej. el primer inicio de sesión en el vehículo)',
	});
	const softwareOnline = getStarsStep({
		index: index++,
		title: 'Software y conectividad',
		name: 'softwareOnline',
		question:
			'las funciones on-line del vehículo? (p. ej. los servicios móviles online, VW Connect…)',
	});
	const softwareIntegracion = getStarsStep({
		index: index++,
		title: 'Software y conectividad',
		name: 'softwareIntegracion',
		question:
			'la integración de dispositivos externos y con la estabilidad de la conexión? (p. ej. para realizar llamadas con manos libres o para utilizar Apple Car Play/Android Auto)',
	});
	const softwareFunciones = getStarsStep({
		index: index++,
		title: 'Software y conectividad',
		name: 'softwareFunciones',
		question:
			'las funciones y la velocidad del sistema de infotainment? (p. ej. la navegación por los menús, el control por voz…)',
	});
	const softwareUpdates = getStarsStep({
		index: index++,
		title: 'Software y conectividad',
		name: 'softwareUpdates',
		question: 'la ejecución de las actualizaciones Over-the-Air?',
	});
	const softwareMotivo = getMotivoStep({
		index: index++,
		title: 'Software y conectividad',
		name: 'softwareMotivo',
	});

	/*
	 * PREGUNTAS SATISFACCION GRUPO ALEATORIO 7
	 */

	const campingInterior = getStarsStep({
		index: index++,
		title: 'Camping',
		name: 'campingInterior',
		question: 'el concepto de interior flexible?',
	});
	const campingEspacio = getStarsStep({
		index: index++,
		title: 'Camping',
		name: 'campingEspacio',
		question: 'el espacio de carga/almacenamiento para acampar?',
	});
	const campingTecho = getStarsStep({
		index: index++,
		title: 'Camping',
		name: 'campingTecho',
		question: 'el funcionamiento y manejo del techo elevable?',
	});
	const campingCocina = getStarsStep({
		index: index++,
		title: 'Camping',
		name: 'campingCocina',
		question: 'el manejo de la cocina?',
	});
	const campingFunciones = getStarsStep({
		index: index++,
		title: 'Camping',
		name: 'campingFunciones',
		question:
			'el control de las funciones de camping mediante interfaces? (p. ej. la unidad de control cámper, la aplicación "Cali on Tour", la aplicación "Cali In Car"…)',
	});
	const campingComodidad = getStarsStep({
		index: index++,
		title: 'Camping',
		name: 'campingComodidad',
		question: 'el concepto de descanso y la comodidad para dormir?',
	});
	const campingEnergia = getStarsStep({
		index: index++,
		title: 'Camping',
		name: 'campingEnergia',
		question:
			'el suministro de energía y la autosuficiencia para las funciones de camping?',
	});
	const campingMotivo = getMotivoStep({
		index: index++,
		title: 'Camping',
		name: 'campingMotivo',
	});

	/*
	 * PREGUNTAS SATISFACCION GRUPO ALEATORIO 8
	 */

	const generalCalidad = getStarsStep({
		index: index++,
		title: 'Satisfacción general',
		name: 'generalCalidad',
		question: 'la calidad percibida de tu nuevo vehículo?',
	});
	const generalRelacion = getStarsStep({
		index: index++,
		title: 'Satisfacción general',
		name: 'generalRelacion',
		question: 'la relación calidad-precio?',
	});
	const generalVehiculo = getStarsStep({
		index: index++,
		title: 'Satisfacción general',
		name: 'generalVehiculo',
		question: 'en general con tu nuevo vehículo?',
	});
	const generalMotivo = getMotivoStep({
		index: index++,
		title: 'Satisfacción general',
		name: 'generalMotivo',
	});

	/*
	 * PREGUNTAS FINALES
	 */

	const usoCliente = {
		title: (
			<Text bold appearance={TokenTextAppearance.headline300}>
				El uso que haces de tu vehículo es…
			</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<MultipleCTASelection
						ctaValues={ctasUsoCliente}
						name="usoCliente"
						nextOnClick
					/>
				}
			/>
		),
		screenIndex: index++,
		name: 'usoCliente',
		outputs: ['usoCliente'],
		outputsText: ['usoCliente'],
		outputsIsStars: true,
	};

	const enviarConcesion = {
		title: (
			<>
				Para finalizar, nos gustaría saber si podemos{' '}
				<Text bold>
					enviar tus respuestas a la marca, junto con tu nombre y el
					número de bastidor de tu vehículo, para que puedan usarlos
					para análisis adicionales.
				</Text>{' '}
				Puedes encontrar información sobre el trato de datos personales
				en el link final de la encuesta.
			</>
		),
		alternateTitle: (
			<Text>Podemos enviar tus respuestas a la marca...</Text>
		),
		fields: (
			<LayoutTemplate
				element={
					<div style={{ paddingTop: '20px' }}>
						<Text
							appearance={TokenTextAppearance.copy200}
							staticSize
						>
							Por razones técnicas las respuestas solo podrán ser
							enviadas a todas las partes involucradas a la vez.
							Si no estás de acuerdo, por favor, selecciona “No”.{' '}
						</Text>
						<RadioTextGroup
							name="enviarConcesion"
							options={optionsEnviarConcesion}
						/>
					</div>
				}
			/>
		),
		screenIndex: index++,
		name: 'enviarConcesion',
		outputs: ['enviarConcesion'],
		outputsText: ['enviarConcesion'],
		ctas: optionsEnviarConcesion,
	};

	const datosPersonales = {
		title: (
			<>
				Por favor, <Text bold>introduce o comprueba tus datos:</Text>
			</>
		),
		fields: (
			<LayoutTemplate
				element={
					<div style={{ paddingBottom: '2px' }}>
						<NombreApellidos />
					</div>
				}
			/>
		),
		screenIndex: index++,
		name: 'datosPersonales',
		outputs: ['name', 'surname', 'secondSurname'],
		outputsText: ['name', 'surname', 'secondSurname'],
	};

	const confirmacion = {
		fields: <ConfirmacionCem />,
		screenIndex: index++,
		name: 'confirmacion',
		outputs: ['confirmacion'],
		outputsText: ['confirmacion'],
	};

	function shuffleArray<T>(array: T[]): T[] {
		const shuffled = [...array];
		for (let i = shuffled.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
		}
		return shuffled;
	}

	const steps: Steps[] = [
		firstStep,
		confirmacionDatos,
		confirmacionConcesion,
		seleccionModelo,
		inicioRating,

		// grupo 1
		...shuffleArray([
			conduccionRendimiento,
			conduccionComodidad,
			...(isCombustion || isHibrido ? [conduccionConsumo] : []),
			...(isElectrico || isHibrido ? [conduccionAutonomia] : []),
		]),
		conduccionMotivo,

		// grupo 2 - solo eléctricos y hibridos
		...(isElectrico || isHibrido
			? [
					...shuffleArray([
						rendimientoCargaGestion,
						rendimientoCarga,
					]),
					rendimientoMotivo,
			  ]
			: []),

		// grupo 3
		...shuffleArray([exteriorDiseno, exteriorPuertas, exteriorMaletero]),
		exteriorMotivo,

		// grupo 4
		...shuffleArray([
			interiorDiseno,
			interiorAlmacenamiento,
			interiorAsiento,
			interiorFunciones,
			interiorAC,
		]),
		interiorMotivo,

		// grupo 5
		...shuffleArray([
			asistenciaConduccion,
			asistenciaFuncionalidad,
			asistenciaNavegacion,
		]),
		asistenciaMotivo,

		// grupo 6
		...shuffleArray([
			softwareInicio,
			softwareOnline,
			softwareIntegracion,
			softwareFunciones,
			softwareUpdates,
		]),
		softwareMotivo,

		// grupo 7 - solo camper
		...(isCamper
			? [
					...shuffleArray([
						campingInterior,
						campingEspacio,
						campingTecho,
						campingCocina,
						campingFunciones,
						campingComodidad,
						campingEnergia,
					]),
					campingMotivo,
			  ]
			: []),

		// grupo 8
		...shuffleArray([generalCalidad, generalRelacion, generalVehiculo]),
		generalMotivo,

		// FINAL
		usoCliente,
		enviarConcesion,
		datosPersonales,
		confirmacion,
	];

	return steps;
};
